import VuexPersistence from 'vuex-persist';
import { createStore } from 'vuex'

export default createStore({
    state: {
        randomQuestions: [],
        numerpreguntas: '0',
        isQuestionAnswered: [],
        urlPhotosEvidence: [],
        preguntas: [],
        idUsuario: '',
        idExamenSesion: '',
        idExamenEjecucion: '',
        name: "",
        primerApellido: "",
        categoriaLicencia: "",
        messageParametros: "",
        numNotifi: 0,
        notifi: '',
        intervalNotifi: 0,
        textoHeader: 1,
        btnFinalizar: 0,
        contadorPreguntas: 0,
        questionResponses: [],
        responses: [],
        idExamenTeorico: '',
        fechaInicio: '',
        fechaFin: '',
        fechaFinSesion: '',
        estado: '',
        examenCompletado: '',
        isAuthenticated: false,
        inicioExamen:0,
        spinner: 0,
        inicioTimers: 0
    },
    getters: {

        //Validar si la respuesta ya fue seleccionada 
        validateQuestionResponses: (state) => (IdBancoPregun) => {
            return state.questionResponses.some(el => el.IdBancoPregun === IdBancoPregun);
        },
        validateResponses : (state) => (IdBancoPregun) => {
            return state.responses.some(el => el.IdBancoPregun === IdBancoPregun);
        }
    },
    mutations: {

        //Spinner 
        setSpinner(state,payload){
            state.spinner = payload;
        },

        //Generación de examen
        setRandomQuestions(state, payload) {
            state.randomQuestions.push(payload)
        },
        setNumberQuestions(state, payload) {
            state.numerpreguntas = payload;
        },
        setFechaInicio(state, payload) {
            state.fechaInicio = payload;
        },
        setFechaFin(state, payload) {
            state.fechaFin = payload;
        },
        setFechaFinSesion(state, payload) {
            const { fecha, currentHour } = payload
            state.fechaFinSesion = fecha + " " + currentHour;
        },
        setIdExamenTorico(state, payload) {
            state.idExamenTeorico = payload;
        },
        setExamenCompletado(state, payload) {
            state.examenCompletado = payload;
        },
        setBtnFinalizar(state, btnFinalizar) {
            state.btnFinalizar = btnFinalizar;
        },
        setContadorPreguntas(state, contadorPreguntas) {
            state.contadorPreguntas = contadorPreguntas
        },
        setInicioExmen(state,payload){
            state.inicioExamen= payload
            var element = document.getElementById("v-step-1");
            if(state.inicioExamen === 1 ){
                element.classList.remove("not-active");
            }else if(state.inicioExamen === 2){
                element.classList.add("not-active");
            }
        },
        setIdExamenTeorico(state, payload) {
            state.idExamenTeorico = payload
        },
        setQuestionResponses(state, payload) {
            state.questionResponses.push(payload);
            // console.log('payload', payload)
            state.isQuestionAnswered.push({ "IdBancoPregun": payload.IdBancoPregun, "isAnswered": true })
            // console.log(state.isQuestionAnswered)
        },
        setResponses(state, payload){
            if (!Array.isArray(state.responses)) {
                state.responses = [];
              }
              state.responses.push(payload);
        },
        updateQuestionResponses(state, payload) {
            const { IdBancoPregun, IdRespuesta } = payload
            for (let index = 0; index < state.questionResponses.length; index++) {
                state.questionResponses[index].IdBancoPregun === IdBancoPregun
                    ? state.questionResponses[index].IdRespuesta = IdRespuesta
                    : ""
            }
            // console.log('actualizo')
            // console.log('state.isQuestionAnswered', state.isQuestionAnswered, 'actualizo')
        },
        addUrlEvidence(state, payload) {
            state.urlPhotosEvidence.push(payload);
        },
        setPreguntas(state, payload) {
            state.preguntas = payload
        },

        //temporizador
        setParametros(state, payload) {
            state.messageParametros = payload
        },
        setNumNotificaciones(state, payload) {
            state.numNotifi = payload
        },
        setNotificacionParametro(state, notifi) {
            state.notifi = notifi
        },
        setIntervalNotificaciones(state, intervalNotifi) {
            state.intervalNotifi = intervalNotifi
        },
        setInicioTimers(state, payload) {
            state.inicioTimers = payload
        },

        //header
        setTextoHeader(state, textoHeader) {
            state.textoHeader = textoHeader;
        },

        //Método para cerrar sesión 
        cerrarSesion(state) {
                state.idUsuario = "",
                state.name = "",
                state.primerApellido = "",
                state.examenCompletado = "",
                state.btnFinalizar = 0,
                state.questionResponses = [],
                state.responses = [],
                state.fechaInicio = "",
                state.fechaFin = "",
                state.urlPhotosEvidence = [],
                state.fechaFinSesion = "",
                state.preguntas = [],
                state.randomQuestions = [],
                state.isQuestionAnswered = [],
                state.contadorPreguntas = '',
                state.idExamenTeorico = '',
                state.numerpreguntas = 0,
                state.messageParametros = ""
                state.numNotifi = 0,
                state.notifi = '',
                state.intervalNotifi = 0,
                state.idExamenSesion = '',
                state.idExamenEjecucion= '',
                state.categoriaLicencia = "",
                state.textoHeader = 1,
                state.estado = '',
                state.examenCompletado = '',
                state.isAuthenticated = false,
                state.correoUsuario = "",
                state.inicioExamen = 0,
                state.spinner = 0,
                state.inicioTimers = 0,
                localStorage.clear();
        },
        // info usuario
        setIdUsuario(state, idUsuario) {
            state.idUsuario = idUsuario;
        },
        setNameUsuario(state, name) {
            state.name = name;
        },
        setPrimerApellidoUsuario(state, primerApellido) {
            state.primerApellido = primerApellido;
        },
        setSegundoApellidoUsuario(state, segundoApellido) {
            state.segundoApellido = segundoApellido;
        },
        setCategoriaLicecia(state, categoriaLicencia) {
            state.categoriaLicencia = categoriaLicencia;
        },
 

        //Info examen
        setIdExamenSesion(state, idExamenSesion) {
            state.idExamenSesion = idExamenSesion;
        },
        setidExamenEjecucion(state, payload){
            state.idExamenEjecucion = payload
        },
        setAutentication(state,payload){
            state.isAuthenticated = payload;
        }
    },
    actions: {

        //Servicio para parametrización de notificaciones
        async fetchDataParametros({ commit }) {
            try {
                const res = await fetch(
                    'https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-parametros-ANSV/parametro-ansv'
                )
                const data = await res.json()
                let numeroNotifi = Number(data[0].numeronotificacionesfinexamen)
                commit('setNotificacionParametro', data[0].valorParametro)
                commit('setNumNotificaciones', numeroNotifi)
                commit('setIntervalNotificaciones', data[0].valorParametro / numeroNotifi)
                commit('setParametros', data[0].parametro)
            } catch (error) {
                console.log(error)
            }
        }
    },

    modules: {
    },
    plugins: [
        new VuexPersistence({
            storage: window.localStorage
        }).plugin
    ]
})
